export const API_URL = "https://signatures.mediaxplode.com/tools-backend/";